export enum TimeLapseType {
  Custom = 'custom',
  ThisWeek = 'this-week',
  LastWeek = 'last-week',
  ThisMonth = 'this-month',
  LastMonth = 'last-month',
  Last30Days = 'last-30-days',
  Last180Days = 'last-180-days',
  Last365Days = 'last-365-days',
}
